import { useTranslation } from "react-i18next";
import SearchIcon from "../../../../icons/searchIcon";
import Select from "../../../../components/select/select";
import DataTable from "../../../../components/table/dataTable";
import EyeIcon from "../../../../icons/eyeIcon";
import EditIcon from "../../../../icons/editIcon";
import { useState } from "react";
import Popup from "../../../../components/popups/popup";
import Map from "../../../../components/map/map";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import TruckIcon from "../../../../icons/truckIcon";
import { useFormik } from "formik";
import DateInput from "../../../../components/inputs/dateInput";
import BoardTextInput from "../../../../components/inputs/dashboardTextInput";
import BoardSelect from "../../../../components/select/dashboardSelect";
import { getContrastingTextColor, primaryColor } from "../../../../utils";

const LastUpdatedShipments = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const editFormik = useFormik({ initialValues: {} });
  const [selected, setSelected] = useState(null);
  const deliveryStatusOptions = [
    { label: t("all"), value: "all" },
    { label: t("delivered"), value: "delivered" },
    { label: t("inPort"), value: "in_port" },
    { label: t("shippingInProgress"), value: "shipping_in_progress" },
  ];
  const shipmentType = [
    { label: t("all"), value: "all" },
    { label: t("normal"), value: "normal" },
    { label: t("fast"), value: "fast" },
  ];
  const citiesOptions = [
    { label: "All", value: "all" },
    { label: "Paris", value: "paris" },
    { label: "dubai", value: "dubai" },
    { label: "Istanbul", value: "istanbul" },
    { label: "London", value: "london" },
  ];
  const tableHead = [
    { header: t("shipmentNumber"), accessorKey: "shipmentNumber" },
    { header: t("customerName"), accessorKey: "customerName" },
    { header: t("shipmentDate"), accessorKey: "shipmentDate" },
    { header: t("destination"), accessorKey: "destination" },
    { header: t("currentStatus"), accessorKey: "currentStatus" },
    { header: t("type"), accessorKey: "type" },
    { header: t("actions"), accessorKey: "actions" },
  ];
  const shipmentData = [
    {
      shipmentNumber: "ORDER1001",
      customerName: "علي ياسر",
      shipmentDate: "27/07/2024",
      destination: "باريس",
      currentStatus: "تم التسليم",
      type: "عادي",
      actions: "تفاصيل",
    },
    {
      shipmentNumber: "ORDER1002",
      customerName: "محمد أحمد",
      shipmentDate: "28/07/2024",
      destination: "لندن",
      currentStatus: "جاري الشحن",
      type: "مستعجل",
      actions: "تتبع",
    },
    {
      shipmentNumber: "ORDER1003",
      customerName: "سارة خالد",
      shipmentDate: "29/07/2024",
      destination: "اسطنبول",
      currentStatus: "في الميناء",
      type: "عادي",
      actions: "إلغاء",
    },
    {
      shipmentNumber: "ORDER1004",
      customerName: "نورا عبدالله",
      shipmentDate: "30/07/2024",
      destination: "دبي",
      currentStatus: "متأخر",
      type: "مستعجل",
      actions: "تعديل",
    },
  ];
  const tableData = shipmentData.map((d, i) => {
    const destination = (
      <span className="font-medium" style={{ color: primaryColor }}>
        {d.destination}
      </span>
    );
    const currentStatus = (
      <span
        className="py-2 w-[100px] block mx-auto rounded-lg bg-[#E6F4EF]"
        style={{ color: getContrastingTextColor("#E6F4EF") }}
      >
        {d.currentStatus}
      </span>
    );
    const actions = (
      <div className="flex items-center justify-center gap-2">
        <span
          onClick={() => {
            setShow(true);
            setSelected(d);
          }}
        >
          <EyeIcon className="cursor-pointer" />
        </span>
        <span
          onClick={() => {
            setEdit(true);
            setSelected(d);
          }}
        >
          <EditIcon className="cursor-pointer" fill={primaryColor} />
        </span>
      </div>
    );
    return {
      shipmentNumber: d.shipmentNumber,
      customerName: d.customerName,
      shipmentDate: d.shipmentDate,
      destination,
      currentStatus,
      type: d.type,
      actions,
    };
  });
  const shipmentStatus = [
    {
      status: "تم استلام الطلب",
      date: "2025-05-28",
      time: "10:30 ص",
      icon: "check", // ✔️
      done: true,
    },
    {
      status: "تم تجهيز الشحنة",
      date: "2025-05-28",
      time: "02:15 م",
      icon: "check", // ✔️
      done: true,
    },
    {
      status: "جاري التوصيل",
      date: "2025-05-29",
      time: "09:45 ص",
      icon: "delivery", // 🚚
      done: false,
    },
  ];
  return (
    <div className="min-w-full p-5 capitalize bg-white rounded-2xl dark:bg-gray-900">
      <section className="flex border-b border-b-[#888888] pb-2 items-center justify-between">
        <div className="font-medium dark:text-white">{t("lastUpdatedShipments")}</div>
        <div className="flex border  border-[#F9F9F9] dark:border-gray-700 dark:bg-gray-800 dark:focus-within:border-white focus-within:border-black items-center gap-4 bg-[#F9F9F9] rounded-full px-4">
          <SearchIcon />
          <input
            type="text"
            className="flex-1 py-2 bg-transparent focus:border-none focus-visible:outline-none"
            placeholder={t("searchShipment")}
          />
        </div>
        <div className="flex items-center justify-center gap-1">
          <Select options={deliveryStatusOptions} placeholder={t("status")} />
          <Select options={citiesOptions} placeholder={t("destination")} />
        </div>
      </section>
      <div className="min-w-full my-5 overflow-x-auto">
        <DataTable TableHead={tableHead} TableData={tableData} />
      </div>
      <Popup state={show} setState={setShow} header={t("shipmentDetails")}>
        <section className="flex flex-wrap max-h-[600px] gap-4 overflow-auto md:flex-nowrap">
          <section className="w-full space-y-4">
            <div>
              <h5 className="font-medium text-black capitalize dark:text-white">
                {t("shipmentInfo")}
              </h5>
              <div className="p-4 rounded-lg bg-[#F2F4F6] dark:bg-gray-800">
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("shipmentNumber")}
                  </span>
                  <span className="text-black dark:text-white">
                    {selected?.shipmentNumber}
                  </span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("shipmentDate")}
                  </span>
                  <span className="text-black dark:text-white">
                    {selected?.shipmentDate}
                  </span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("currentStatus")}
                  </span>
                  <span className="text-black dark:text-white">
                    {selected?.currentStatus}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <h5 className="font-medium text-black capitalize dark:text-white">
                {t("customerInfo")}
              </h5>
              <div className="p-4 rounded-lg bg-[#F2F4F6] dark:bg-gray-800">
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("customerName")}
                  </span>
                  <span className="text-black dark:text-white">
                    {selected?.customerName}
                  </span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("city")}
                  </span>
                  <span className="text-black dark:text-white">
                    {selected?.destination}
                  </span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("phone")}
                  </span>
                  <span className="text-black dark:text-white">4567 123 50 966+</span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("address")}
                  </span>
                  <span className="text-black dark:text-white">
                    شارع المك فهد حي العليا
                  </span>
                </p>
              </div>
            </div>

            <div>
              <h5 className="font-medium text-black capitalize dark:text-white">
                {t("productDetails")}
              </h5>
              <div className="p-4 rounded-lg bg-[#F2F4F6] dark:bg-gray-800">
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("quantity")}
                  </span>
                  <span className="text-black dark:text-white">3</span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("totalWeight")}
                  </span>
                  <span className="text-black dark:text-white">25 جم</span>
                </p>
                <p className="flex items-center justify-between gap-4">
                  <span className="font-medium text-mainGray dark:text-gray-400">
                    {t("shipmentValue")}
                  </span>
                  <span className="text-black dark:text-white">1,250ريال</span>
                </p>
              </div>
            </div>
          </section>

          <section className="min-w-[300px] space-y-4 w-full">
            <div>
              <h5 className="font-medium text-black capitalize dark:text-white">
                {t("trackShipment")}
              </h5>
              <div className="p-4 rounded-lg bg-[#F2F4F6] dark:bg-gray-800">
                {shipmentStatus.map((step, idx) => (
                  <div key={idx} className="flex items-start gap-2 text-right">
                    <div className="flex flex-col items-center px-1 pt-1">
                      {step.done ? (
                        <ShipmentDeliveredIcon className="w-5 h-5 text-green-500" />
                      ) : (
                        <TruckIcon fill="#3b82f6" className="w-5 h-5 text-blue-500" />
                      )}
                      {idx < shipmentStatus.length - 1 && (
                        <div className="w-[2px] h-6 bg-gray-300 dark:bg-gray-600 mt-1"></div>
                      )}
                    </div>
                    <div className="flex flex-col text-sm">
                      <span className="font-medium text-black dark:text-white">
                        {step.status}
                      </span>
                      <span className="text-xs text-gray-500 dark:text-gray-400">
                        {step.time} - {step.date}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h5 className="font-medium text-black capitalize dark:text-white">
                {t("shipmentLocation")}
              </h5>
              <div className="p-4 rounded-lg bg-[#F2F4F6] dark:bg-gray-800">
                <Map onLocationSelect={() => {}} />
              </div>
            </div>
          </section>
        </section>
      </Popup>
      <Popup state={edit} setState={setEdit} header={t("editShipmentDetails")}>
        <div className="md:min-w-[400px] border-b border-b-[#CDD0D6] dark:border-b-gray-700 pb-4">
          <BoardTextInput
            formik={editFormik}
            name={"shipmentNumber"}
            placeholder={selected?.shipmentNumber}
            label={t("shipmentNumber")}
          />
          <BoardTextInput
            formik={editFormik}
            name={"customer"}
            placeholder={selected?.customerName}
            label={t("customer")}
          />
          <BoardTextInput
            formik={editFormik}
            name={"destination"}
            placeholder={selected?.destination}
            label={t("city")}
          />
          <BoardSelect
            options={deliveryStatusOptions}
            formik={editFormik}
            name={"deliveryStatus"}
            placeholder={selected?.currentStatus}
            label={t("status")}
          />
          <BoardSelect
            options={shipmentType}
            formik={editFormik}
            name={"type"}
            placeholder={selected?.type}
            label={t("type")}
          />
          <div className="w-full">
            <DateInput label={t("date")} />
          </div>
        </div>

        <div className="flex items-center gap-4 my-4">
          <button
            className="px-2 py-2 text-white rounded-lg hover:opacity-85"
            style={{
              backgroundColor: primaryColor,
              color: getContrastingTextColor(primaryColor),
            }}
          >
            {t("saveChanges")}
          </button>
          <button className="rounded-lg bg-[#F2F4F6] dark:bg-gray-800 text-black dark:text-white py-2 px-2 hover:opacity-85">
            {t("cancel")}
          </button>
        </div>
      </Popup>
    </div>
  );
};

export default LastUpdatedShipments;
